// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Inter';
  src: url('https://assets.zupee.com/wordpress/assets/fonts/inter-400.woff2') format('truetype');
  font-display: swap;
}

@font-face {
  font-family: 'Inter';
  src: url('https://assets.zupee.com/wordpress/assets/fonts/inter-600.woff2') format('truetype');
  font-display: swap;
}

@font-face {
  font-family: 'SignPainter HouseSlant';
  font-style: normal;
  font-weight: 400;
  src:url('https://assets.zupee.com/wordpress/assets/fonts/SignPainter-HouseSlant-Regular.ttf') format('truetype');
  font-display: swap
}`, "",{"version":3,"sources":["webpack://./src/styles/font.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,8FAA8F;EAC9F,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,8FAA8F;EAC9F,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gHAAgH;EAChH;AACF","sourcesContent":["@font-face {\n  font-family: 'Inter';\n  src: url('https://assets.zupee.com/wordpress/assets/fonts/inter-400.woff2') format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Inter';\n  src: url('https://assets.zupee.com/wordpress/assets/fonts/inter-600.woff2') format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'SignPainter HouseSlant';\n  font-style: normal;\n  font-weight: 400;\n  src:url('https://assets.zupee.com/wordpress/assets/fonts/SignPainter-HouseSlant-Regular.ttf') format('truetype');\n  font-display: swap\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
